import React from 'react'
import { Typography } from '@chilecompra/react-kit/components'
import { Content, Root } from './Home.styles'
import { useParams, useNavigate } from 'react-router-dom'
import { localStorageOrgCode, localStorageProviderId } from '../../config/settings/constants'

/**
 * The Home's container.
 */
const Home = () => {
  const { providerId } = useParams()
  const { orgCode } = useParams()
  const { id } = useParams()
  const navigate = useNavigate()
  localStorage.setItem(localStorageProviderId, providerId)
  localStorage.setItem(localStorageOrgCode, orgCode)
  React.useEffect(() => {
    return navigate(`/adjustment/${id}`)
  })

  return (
    <Root>
      <Content>
        <Typography fontSize="22px" lineHeight="26px" variant="h1">
          Proyecto Iniciado
        </Typography>
      </Content>
    </Root>
  )
}

export default Home
